import styled from "styled-components";

import { SelectStyledProps as Props } from "./Select.types";

const SelectStyled = styled.div<Props>`
  .Select {
    &__label {
      font-size: 1.2rem;
      padding-bottom: 0.4rem;
      padding-left: 0.8rem;
    }

    &__dropdown {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 0.1rem solid var(--palette-gray-s0-l75);
      border-radius: 1.2rem;
      padding: 1.6rem 1.4rem;
      outline: none;
      width: 100%;
      background-color: var(--palette-white);

      &:hover {
        z-index: 1;
        border-color: var(--palette-primary);
      }

      &:disabled {
        background-color: var(--palette-gray-s0-l90);
        color: var(--palette-gray-s0-l50);
        border-color: transparent;
        font-weight: bold;
      }
    }

    &__option {
      font-size: 1.6rem;
      font-weight: 600;
      padding-bottom: 1.6rem;
      border-bottom: 0.1rem solid var(--palette-gray-s0-l90);
      border: none;
      outline: none;
    }

    &__description {
      font-size: 1rem;
      color: var(--palette-grey-blue-s15-l80);
      padding-left: 1.6rem;
      padding-top: 0.4;
    }

    &__error {
      font-size: 1.2rem;
      color: var(--palette-red-s60-l60);
      padding-top: 0.4rem;
    }
  }
`;

export const SelectOverlay = styled.div<Props>`
  .SelectOverlay {
    &__item {
      font-size: 1.6rem;
      font-weight: 600;
      padding-bottom: 1.6rem;
      border-bottom: 0.1rem solid var(--palette-gray-s0-l90);
    }
  }
`;

export default SelectStyled;
